// code for sticky add to cart on the product page : start
// document.addEventListener("DOMContentLoaded", function () {
//     const buttonBlock = document.querySelector(".mlv-sticky-addbtn");
//     if (!buttonBlock) return;
//     if (window.innerWidth > 768) return; // Apply only on mobile

//     let lastScrollTop = window.scrollY; // Store last scroll position

//     function handleScroll() {
//         let currentScroll = window.scrollY;

//         const buttonwishlistBlock = document.querySelector(".mlv-sticky-addbtn .swym-button-bar");
//         if (!buttonwishlistBlock) return; // If the button is not found, do nothing

//         if (currentScroll > lastScrollTop) {
//             // Scrolling down -> Show the wishlist button and make it sticky
//             buttonBlock.style.position = "sticky";
//             buttonBlock.style.width = "unset";
//             buttonwishlistBlock.style.display = "inline-block";
//         } else {
//             // Scrolling up -> Hide the wishlist button and reset position
//             buttonBlock.style.position = "";
//             buttonBlock.style.width = "";
//             buttonwishlistBlock.style.display = "none";
//         }

//         lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative values
//     }

//     // Observe changes in the button container to detect when the wishlist button is added
//     const observer = new MutationObserver(() => {
//         const buttonwishlistBlock = document.querySelector(".mlv-sticky-addbtn .swym-button-bar");
//         if (buttonwishlistBlock) {
//             buttonwishlistBlock.style.display = "none"; // Initially hide the wishlist button
//             window.addEventListener("scroll", handleScroll);
//             observer.disconnect(); // Stop observing once the button is found
//         }
//     });

//     observer.observe(buttonBlock, { childList: true, subtree: true });
// });

// original code commented on 27/6/26 document.addEventListener("DOMContentLoaded", function () {
//   const stickyBtnWrapper = document.querySelector(".mlv-sticky-addbtn");

//   // commented because need the sticky button in desktop as well this code only for the mobile sticky cart if (!stickyBtnWrapper || window.innerWidth > 767) return;
//   if (!stickyBtnWrapper) return;

//   // Get the button's original offset from top
//   const originalOffsetTop = stickyBtnWrapper.offsetTop;

//   let lastScrollY = window.scrollY;

//   const handleScroll = () => {
//     const currentScroll = window.scrollY;
//     const scrollingUp = currentScroll < lastScrollY;
//     lastScrollY = currentScroll;

//     const rect = stickyBtnWrapper.getBoundingClientRect();
//     const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

//     if (scrollingUp) {
//       stickyBtnWrapper.classList.add("fixed");
//     } else {
//       // scrolling down
//       if (window.scrollY + window.innerHeight >= originalOffsetTop + stickyBtnWrapper.offsetHeight) {
//         stickyBtnWrapper.classList.remove("fixed");
//       } else {
//         stickyBtnWrapper.classList.add("fixed");
//       }
//     }
//   };

//   // Add fixed class on load (in case it's not in view)
//   stickyBtnWrapper.classList.add("fixed");

//   window.addEventListener("scroll", handleScroll);
// });

// comment on 27/6/26 document.addEventListener("DOMContentLoaded", function () {
//   const stickyBtnWrapper = document.querySelector(".mlv-sticky-addbtn");

//   if (!stickyBtnWrapper) return;

//   // Get the button's original position from the top of the page
//   const originalOffsetTop =
//     stickyBtnWrapper.getBoundingClientRect().top + window.scrollY;

//   const handleScroll = () => {
//     if (window.scrollY > originalOffsetTop) {
//       stickyBtnWrapper.classList.add("fixed");
//     } else {
//       stickyBtnWrapper.classList.remove("fixed");
//     }
//   };

//   // Run once on load
//   handleScroll();

//   window.addEventListener("scroll", handleScroll);
// });

document.addEventListener("DOMContentLoaded", function () {
  const stickyBtnWrapper = document.querySelector(".mlv-sticky-addbtn");

  if (!stickyBtnWrapper) return;

  const isMobile = window.innerWidth <= 767;

  // Desktop: original position of the button
  const originalOffsetTop =
    stickyBtnWrapper.getBoundingClientRect().top + window.scrollY;

  const handleScroll = () => {
    if (window.innerWidth <= 767) {
      // Mobile: always visible
      stickyBtnWrapper.classList.add("fixed");
    } else {
      // Desktop: become sticky only after scrolling past original position
      if (window.scrollY > originalOffsetTop) {
        stickyBtnWrapper.classList.add("fixed");
      } else {
        stickyBtnWrapper.classList.remove("fixed");
      }
    }
  };

  // Run once on load
  handleScroll();

  window.addEventListener("scroll", handleScroll);

  // Handle viewport changes (orientation change / resize)
  window.addEventListener("resize", handleScroll);
});
// code for sticky add to cart on the product page : end
// code for add magnifier effect in product thumbnail in the product page : start
  jQuery(document).ready(function(){
    jQuery('.product-image-main .image-element')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: jQuery(this).find('img').attr('data-zoom')
    });
  });
// code for add magnifier effect in product thumbnail in the product page : end

// Code to select the Item Id metafield value according to the variant change
document.addEventListener('DOMContentLoaded', function() {
    // Get the hidden variant ID input
    const variantInput = document.querySelector('.formVariantId');
    if (!variantInput) return;
    // Select the variant metafield display element
    const variantMetafieldDisplay = document.getElementById('variant-metafield');
    const variantMetafieldDisplaycheckout = document.getElementById('mlItemId');
    // Select the hidden variant metafields select element
      const hiddenVariantMetafields = document.getElementById('hidden-variant-metafields');
      const updateMetafieldDisplay = () => {
      const selectedVariantId = variantInput.value;
      const selectedOption = hiddenVariantMetafields.querySelector(`option[value="${selectedVariantId}"]`);
      if (selectedOption) {
       // console.log(selectedOption);
        const metafieldValue = selectedOption.getAttribute('data-metafield');
        //console.log("metafieldValue",metafieldValue);
        if(variantMetafieldDisplay) {
          variantMetafieldDisplay.innerHTML = metafieldValue;
        }
        const metafieldValuecheckout = selectedOption.getAttribute('checkoutitemid');
        if(variantMetafieldDisplaycheckout) {
          variantMetafieldDisplaycheckout.setAttribute("value", metafieldValuecheckout);
        }
      }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(updateMetafieldDisplay);
    // Start observing the target node for configured mutations
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    // Initial update on page load
    updateMetafieldDisplay();
});
// End code to select the Item Id metafield value according to the variant change